const API_URL = "https://api.host-age.in";

export default API_URL;

export const PAYMENT_API = "https://payment-api.host-age.in";
